<div class="ventilation-settings-tile flex flex-col gap-[24px] flex-[1_0_100%]">
  <div class="flex flex-row">
    <h3>{{ '+INSTALLATIONS.INSTALLATION.FROST_PROTECTION.TITLE' | translate }}</h3>
  </div>

  <ng-container
    *ngIf="
      data.properties.type.value !== frostProtectionType.undefined;
      else emptyFrostProtectionType
    "
  >
    <mat-form-field mat-select-height-large>
      <mat-label>{{
        '+INSTALLATIONS.INSTALLATION.FROST_PROTECTION.HEAT_EXCHANGER_TYPE' | translate
      }}</mat-label>
      <mat-select
        data-at-heat-exchanger-type-configuration
        name="{{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SELECT_OPERATING_MODE' | translate }}"
        [(ngModel)]="selectedHeatExchangerType"
        (selectionChange)="onSelectFrostProtectionType($event)"
      >
        <ng-container *ngFor="let mode of frostProtectionFilters">
          <mat-option *ngIf="mode.isShow" [value]="mode.value">
            {{ mode.viewValue }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <div
      class="flex flex-column"
      *ngIf="
        ventilationHeatExchangerFrostProtection$
          | async
          | ready as ventilationHeatExchangerFrostProtection
      "
    >
      <mat-radio-group class="flex flex-col gap-[8px]">
        <ng-container *ngFor="let mode of operatorModes">
          <div *ngIf="mode.isShow" class="flex flex-row gap-[8px]">
            <div class="operation-mode-option">
              <vi-radio-button
                [attr.data-at-operation-mode]="mode.value"
                [value]="mode.value"
                [label]="mode.viewValue"
                [checked]="
                  mode.value === ventilationHeatExchangerFrostProtection.properties?.value.value
                "
                [attr.data-at-checked]="
                  mode.value === ventilationHeatExchangerFrostProtection.properties?.value.value
                "
                [disabled]="!mode.isWrite"
                (optionChange)="onOperationModeChange($event)"
              ></vi-radio-button>
            </div>
            <mat-icon
              class="info-icon"
              [matTooltip]="
                (mode.value === ventilationHeatExchangerFrostProtectionType.preheater ||
                  mode.value === ventilationHeatExchangerFrostProtectionType.preheaterEcoMode) &&
                !mode.isWrite
                  ? ('+INSTALLATIONS.INSTALLATION.FROST_PROTECTION.OPERATION_MODES.PREHEATER_DISABLED_TOOLTIP'
                    | translate)
                  : mode.tooltipContent
              "
              matTooltipPosition="right"
            >
              info
            </mat-icon>
          </div>
        </ng-container>
      </mat-radio-group>
    </div>
  </ng-container>

  <ng-template #emptyFrostProtectionType>
    <div class="flex items-center gap-2">
      <p>
        {{ '+INSTALLATIONS.INSTALLATION.FROST_PROTECTION.UNDEFINED_MESSAGE' | translate }}
      </p>
      <mat-icon>warning</mat-icon>
    </div>
  </ng-template>
</div>
